import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 28px 24px;
  background: white;
  box-shadow: 0px 5px 10px rgba(0, 35, 75, 0.15);
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const HeaderLabel = styled.div`
  color: #6C757D;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  text-transform: uppercase;
`

export const Divider = styled.div`
  width: 1px;
  height: 15px;
  background: #979797;
`

export const AnnouncementsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 28px;
`

export const AnnouncementCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.withAction ? '6px' : '8px'};
`

export const AnnouncementTitle = styled.div`
  color: #00234B;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const NewBadge = styled.span`
  background: #0082CE;
  color: white;
  font-size: 10px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  text-transform: uppercase;
  padding: 2px 6px;
  border-radius: 3px;
  line-height: 1;
`

export const AnnouncementBody = styled.div`
  color: #00234B;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  line-height: 18px;
`

export const AnnouncementLink = styled.a`
  color: #0082CE;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`

export const ReadMoreToggle = styled.span`
  color: #0082CE;
  font-weight: 500;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`

export const ViewMoreLink = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  
  &:hover {
    opacity: 0.8;
  }
`

export const ViewMoreText = styled.div`
  color: #0082CE;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
`

export const LoadingCard = styled.div`
  width: 100%;
  padding: 24px;
  background: white;
  box-shadow: 0px 5px 10px rgba(0, 35, 75, 0.15);
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-height: 400px;
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 25px 10px 25px;
  min-width: 300px;
  width: 100%;
`
